import { Store as StoreModel } from '@core/models';
import { OrderTypeEnum } from '@core/enums';
import { StoreProcessingInput, StoreProcessingResult, StoreProcessingStrategy } from '../interfaces';
import {
	calculateDistanceInKm,
	isStoreInSameCountry,
	isStoreWithinMaxDistance,
} from '../rules';

export class PickupStoresStrategy implements StoreProcessingStrategy {
	readonly code = OrderTypeEnum.Pickup;

	process(input: StoreProcessingInput): StoreProcessingResult {
		const { stores, userLocation, userCountry } = input;
		const storesWithDistance: StoreModel[] = [];

		for (const store of stores ?? []) {
			if (!isStoreInSameCountry(userCountry, store.ubicacion?.pais)) {
				continue;
			}

			let distancia = 0;
			if (
				store.location &&
				typeof store.location.lat === 'number' &&
				typeof store.location.lng === 'number'
			) {
				distancia = calculateDistanceInKm(
					userLocation.lat,
					userLocation.lng,
					store.location.lat,
					store.location.lng
				);
				if (!isStoreWithinMaxDistance(distancia)) {
					continue;
				}
			}

			storesWithDistance.push({ ...store, distancia });
		}

		storesWithDistance.sort((a, b) => (a.distancia ?? 0) - (b.distancia ?? 0));

		return {
			stores: storesWithDistance,
		};
	}
}
